import {LoadingSkeleton} from '@/components/app/feedback';
import {cn} from '@/lib/utils';
export interface BiobookTableOfContentsSkeletonProps {
  className?: string;
}
export const BiobookTableOfContentsSkeleton = ({className}: BiobookTableOfContentsSkeletonProps) => {
  return (
    <div className={cn('h-full flex flex-col', className)}>
      {/* Header section */}
      <div className="px-6 shrink-0">
        <div className="pt-6 pb-2 border-zinc-400">
          <div className="grid grid-cols-[1fr_auto_1fr]">
            <div className="col-start-2">
              <LoadingSkeleton height="1.5rem" width="12rem" className="mx-auto" />
            </div>
            <div className="flex items-center justify-end">
              <div className="flex items-center h-0">
                <LoadingSkeleton height="2.5rem" width="2.5rem" borderRadius="50%" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tree content section */}
      <div className="flex-1 min-h-0 overflow-auto px-6">
        <div className="flex flex-col gap-2 py-4">
          {/* Root level items */}
          <TreeNodeSkeleton level={0} hasChildren />
          <TreeNodeSkeleton level={0} hasChildren />
          <TreeNodeSkeleton level={0} hasChildren />

          {/* Expanded section with children */}
          <div className="flex flex-col gap-2">
            <TreeNodeSkeleton level={0} hasChildren expanded />

            {/* Level 1 children */}
            <div className="flex flex-col gap-2 ml-6">
              <TreeNodeSkeleton level={1} hasChildren />
              <TreeNodeSkeleton level={1} hasChildren expanded />

              {/* Level 2 children */}
              <div className="flex flex-col gap-2 ml-6">
                <TreeNodeSkeleton level={2} hasChildren />
                <TreeNodeSkeleton level={2} hasChildren />
              </div>
            </div>
          </div>

          {/* More root items */}
          <TreeNodeSkeleton level={0} hasChildren />
          <TreeNodeSkeleton level={0} hasChildren />
        </div>
      </div>
    </div>
  );
};
interface TreeNodeSkeletonProps {
  level: number;
  hasChildren?: boolean;
  expanded?: boolean;
}
const TreeNodeSkeleton = ({level, hasChildren = false, expanded = false}: TreeNodeSkeletonProps) => {
  const indentation = level * 1.5; // rem

  return (
    <div
      className="flex items-center gap-2"
      style={{
        height: '45px',
        paddingLeft: `${indentation}rem`,
      }}
    >
      <div className="flex items-center justify-center w-11">
        {hasChildren && <LoadingSkeleton height="1rem" width="1rem" className="shrink-0" />}
      </div>

      {/* Chapter number */}
      <LoadingSkeleton
        height="1rem"
        width={level === 0 ? '1.5rem' : level === 1 ? '2.5rem' : '3rem'}
        className="shrink-0"
      />

      {/* Chapter title */}
      <LoadingSkeleton
        height="1rem"
        width={`${Math.random() * 8 + 6}rem`}
        className="flex-1"
        style={{
          maxWidth: '20rem',
        }}
      />

      {/* Page number */}
      <LoadingSkeleton height="1.5rem" width="2.5rem" borderRadius="1rem" className="shrink-0" />
    </div>
  );
};
